'use client';

import { useFormContext } from 'react-hook-form';
import { cn } from '../../utils';
import { Textarea, type TextareaProps } from '../ui/textarea';
import { FormControl } from './FormControl';

export function FormTextarea(
  props: {
    name: string;
    label: string;
    className?: string;
    formControlClassName?: string;
  } & TextareaProps
) {
  const { register, formState, watch } = useFormContext();
  const value = watch(props.name);

  return (
    <FormControl
      label={props.label}
      name={props.name}
      className={props.formControlClassName}
    >
      <Textarea
        maxLength={props.maxLength}
        disabled={props.disabled || formState.isSubmitting}
        className={cn('w-full', props.className)}
        placeholder={props.placeholder}
        {...register(props.name)}
      />
      {props.maxLength && (
        <div className="mt-1 flex w-full justify-end">
          <p
            className={cn(
              'font-medium text-gray-700 text-xs transition-colors',
              value.length === props.maxLength && 'text-red',
              props.maxLength && '-mb-4'
            )}
          >
            {value.length} / {props.maxLength}
          </p>
        </div>
      )}
    </FormControl>
  );
}
